import { DELIVERABILITY_STATUS } from '@nandosaus/constants';

/**
 * Whether the delivery address can be confirmed, and which DeliveryError status to show if not.
 *
 * Catering delivery shows the resolved store instead of DeliveryEstimate, so it loses that
 * component's "outside of our deliverable area" fallback. The API resolves the nearest
 * catering-enabled store, which may not be delivery-enabled (deliveryRestaurant is then empty):
 * treat that as outside the delivery area rather than a disabled button with no error.
 */
const getDeliveryLocationStatus = ({ deliverabilityStatus, deliveryRestaurant, isCateringDelivery }) => {
  const isDeliverable = deliverabilityStatus === DELIVERABILITY_STATUS.DELIVERABLE;

  if (isCateringDelivery && isDeliverable && !deliveryRestaurant) {
    return { isValid: false, errorStatus: DELIVERABILITY_STATUS.OUTSIDE_DELIVERY_AREA };
  }

  return { isValid: isDeliverable, errorStatus: deliverabilityStatus };
};

export { getDeliveryLocationStatus };
